export default __webpack_public_path__ + "static/media/profile.dfaf44e3.jpg";